var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","page-sizes":_vm.MixinPageSizes,"page-size":_vm.paginations.pageSize,"layout":_vm.paginations.layout,"total":_vm.pageTotal,"current-page":_vm.paginations.pageIndex},on:{"current-change":_vm.handlePageCurrentChange,"size-change":_vm.handlePageSizeChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }